export const name = 'paypalButton' as const
